import {
    React, RouteComponentProps,
    Formsy, form, formHelpers,
    i18n,
    observable, inject, observer,
    mui, ui, theme, styled, pr,
    api, apiClient,
    debug
} from "aaa";

import { Auth } from "models/Auth";
import * as _ from "lodash";
import { Link } from "react-router-dom";



type IProps = RouteComponentProps<{
    resetToken?: string
}> & i18n.InjectedIntlProps & {
        auth: Auth
    };


@i18n.injectIntl
@inject("auth")
@observer
export class SetPassword extends React.Component<IProps, {}> {

    @observable
    formIsValid = true;


    onSubmit = async (fields: any, resetForm: any, invalidateForm: any) => {
        if (fields.password !== fields.passwordRepeat) {
            invalidateForm({ passwordRepeat: ui.__("password.mismatch") });
        }

        const resetToken = this.props.match.params.resetToken;
        if (!resetToken) {
            if (this.props.auth.token) {
                // Change password case
                const request = api.changePassword(fields.password);
                try {
                    await apiClient.request(request, true);
                    this.props.history.push("/interest-rates");
                } catch (error) {
                    ui.showGenericError(error.statusCode);
                }
            }
        } else {
            // Password forgotten case
            const request = api.setPassword(resetToken, fields.password);
            try {
                this.props.auth.token = await apiClient.requestType(request);
                this.props.history.push("/interest-rates");
            } catch (error) {
                ui.showGenericError(error.statusCode);
            }
        }
    }

    render() {
        return (
            <div style={{ padding: theme.MARGIN_BIG }}>
                <Formsy.Form
                    onValidSubmit={this.onSubmit}
                    onValid={() => { this.formIsValid = true; }}
                    onInvalid={() => { this.formIsValid = false; }}
                >
                    <form.FormsyText
                        name="password"
                        type="password"
                        required={true}
                        validations="minLength:6"
                        validationError={ui.__("password.tooShort")}
                        floatingLabelText={ui.__("password.textField")}
                        fullWidth={true}
                    />
                    <form.FormsyText
                        name="passwordRepeat"
                        type="password"
                        required={true}
                        validations="minLength:6"
                        validationError={ui.__("password.tooShort")}
                        floatingLabelText={ui.__("password.repeat")}
                        fullWidth={true}
                    />
                    <br /><br />
                    {formHelpers.renderActionButton(ui.__("password.action"))}
                </Formsy.Form>
            </div >
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/SetPassword.tsx